import { Field } from "components/shared/form";
import { fuelTankTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { Component } from "react";

export default class FuelTanks extends Component {
    renderField = ({ inputProps, ...props }, index) => {
        const { fuelTanks, canEditBooks, setValue } = this.props;
        return (
            <Field
                key={props.label}
                wrapper="panel__row"
                onChange={({ name, value }) => {
                    const newItems = fuelTanks.map((item, i) => (index === i ? { ...item, [name]: value } : item));
                    setValue({ name: "fuelTanks", value: newItems });
                }}
                value={fuelTanks[index][inputProps.name]}
                inputProps={{ ...inputProps, disabled: !canEditBooks }}
                {...props}
            />
        );
    };

    renderFuelTank = (fuelTank, index) => {
        const { config } = this.props.config;
        return (
            <div key={index}>
                <div className="row">
                    <small className="text-muted offset-sm-4 offset-md-3 col-md-9 col-sm-8">
                        <strong>
                            Топливный бак №{index + 1} - {enumLabel(fuelTankTypes, fuelTank.type)}
                        </strong>
                    </small>
                </div>
                {this.renderField(config.totalVolume, index)}
                {this.renderField(config.fuelConsumption, index)}
                {this.renderField(config.minimumVolume, index)}
            </div>
        );
    };

    render() {
        return this.props.fuelTanks.map(this.renderFuelTank);
    }
}
